import React, {
  useLayoutEffect, useState, useEffect, useRef, memo, useCallback
} from 'react';
import _, { find } from 'lodash';
import cn from 'classnames';
import styles from './orders.module.scss';

const WrapperComponent = memo(({
  props, activeIndex, menuIndex, toggleMenu, scrollCat, selectedOption, buttonSelected
}) => {
  return (
    <>
      {props.menusList && props.menusList.map((menuItem, key) => {
        return (
          <>
            <div key={menuItem.id} className={cn('col-12 p-2 row mx-0')} role="presentation" onClick={() => toggleMenu(key)}>
              <div className="col-10 p-0 fw-600">{menuItem?.name}</div>
              <div className="col-2 col-md-2 p-0 text-right"><i className={activeIndex === key ? 'fas fa-caret-up mr-1' : 'fas fa-caret-down mr-1'} /></div>
            </div>
            <div className={activeIndex === key ? 'd-block w-100 overflowY maxH-70' : 'd-none'}>
              {props.menusList[menuIndex] && props.menusList[menuIndex].screens.length > 0 ? (
                <div className={cn('col-12 px-1')} ref={scrollCat} id="scrollCat">
                  {props.menusList[menuIndex].screens.map((data) => {
                    const highlightOptions = (selectedOption && (data.id === selectedOption.id)) ? `${styles.selectedCategory}` : '';
                    return (
                      <button
                              // ref={ref => findActiveRef(ref, data.id)}
                        key={data.id}
                        type="button"
                        className={cn(window.innerWidth > 799 ? styles.dtcategory : styles.category, highlightOptions, 'text-left od-text-primary text-primary')}
                        onClick={() => { buttonSelected(data); }}
                      >
                        {data.name}
                      </button>
                    );
                  })}
                </div>
              ) : (
                (!props.loading && !props.menuLoading) && (
                <div className="d-flex justify-content-center align-items-center" />
                )
              )}
            </div>
          </>
        );
      })}
    </>
  );
}, (prevProps, nextProps) => {
  return _.isEqual(prevProps, nextProps);
});

const Orders = (props) => {
  const scrollCat = useRef(null);
  const {
    menuIndex,
    onClickMenu,
    // innerMenu
  } = props;

  const [selectedOption, setSelectedOption] = useState([]);
  const [displayFooter, setDisplayFooter] = useState(true);
  const [activeIndex, setActiveIndex] = useState(null);

  const buttonSelected = useCallback((options) => {
    window.sessionStorage.setItem('menuName', options.name);
    window.sessionStorage.setItem('menuTypeId', options.id);
    window.sessionStorage.setItem('scrol', window.pageYOffset);
    setSelectedOption(options);
    onClickMenu(options.id);
  }, [selectedOption]);
  useEffect(() => {
    if (props.menusList[menuIndex]) {
      if (window.sessionStorage.getItem('menuTypeId') && find(props.menusList[menuIndex].screens, { id: Number(window.sessionStorage.getItem('menuTypeId')) })) {
        setSelectedOption(find(props.menusList[menuIndex].screens, { id: Number(window.sessionStorage.getItem('menuTypeId')) }));
        window.sessionStorage.setItem('menuTypeId', find(props.menusList[menuIndex].screens, { id: Number(window.sessionStorage.getItem('menuTypeId')) }).id);
      } else {
        setSelectedOption(props.menusList[menuIndex].screens[0] || []);
        window.sessionStorage.setItem('menuTypeId', (props?.menusList?.[menuIndex]?.screens?.[0]?.id) || []);
      }
    }
  }, [props.menusList, menuIndex]);

  useEffect(() => {
    if (window.sessionStorage.getItem('menuScreen')) {
      setSelectedOption(JSON.parse(window.sessionStorage.getItem('menuScreen')));
    }
  }, [window.sessionStorage.getItem('menuScreen')]);

  const refs = useRef(null);

  const dissmissableFooter = JSON.parse(window.sessionStorage.getItem('dissmissableFooter'));
  useEffect(() => {
    if (refs?.current?.offsetHeight) {
      props.handleFooter(refs.current.offsetHeight);
    } else props.handleFooter(0);
    if (dissmissableFooter?.some((ele) => ele === selectedOption.id)) {
      setDisplayFooter(false);
    } else {
      setDisplayFooter(true);
    }
  }, [selectedOption?.id, dissmissableFooter, displayFooter]);

  const onMenuChangeHandler = (key) => {
    if (props.isBrowse) {
      props.changeMenuByIndex(key).then(() => {
        props.handleMenuChangeNavigation();
      });
    } else {
      window.sessionStorage.removeItem('menuTypeId');
      window.sessionStorage.removeItem('scrol');
      window.sessionStorage.removeItem('isTile');
      window.sessionStorage.removeItem('menuName');
      props.changeMenu(key);
      props.handleMenuChangeNavigation();
    }
  };

  const toggleMenu = (key) => {
    if (activeIndex === key) {
      setActiveIndex(null);
    } else {
      setActiveIndex(key);
      onMenuChangeHandler(key);
    }
  };

  useLayoutEffect(() => {
    if (window.sessionStorage.getItem('menuTypeId')) {
      onClickMenu(window.sessionStorage.getItem('menuTypeId'));
    }
  }, []);

  useEffect(() => {
    setActiveIndex(menuIndex);
  }, [menuIndex]);
  return (
    <div className={cn('h-100 fs-12 border border-color-primary overflowY od-header-font-family od-app-background-color rounded od-container-card-border')}>
      <div className="h-95">
        <WrapperComponent props={props} activeIndex={activeIndex} menuIndex={menuIndex} selectedOption={selectedOption} toggleMenu={toggleMenu} buttonSelected={buttonSelected} scrollCat={scrollCat} />
      </div>
    </div>
  );
};

export default Orders;
